<template>
    <section
        v-editable="blok"
        class="article-table"
    >
        <KTable
            :caption="blok.name || undefined"
            caption-visibility="visually-hidden"
        >
            <thead v-if="headers.length">
                <tr>
                    <th
                        v-for="(column, index) in headers"
                        :key="column._uid || index"
                        scope="col"
                    >
                        {{ column.value }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="(row, rowIndex) in rows"
                    :key="row._uid || rowIndex"
                >
                    <td
                        v-for="(cell, cellIndex) in row.body"
                        :key="cell._uid || cellIndex"
                    >
                        {{ cell.value }}
                    </td>
                </tr>
            </tbody>
        </KTable>
    </section>
</template>

<script setup lang="ts">
import { KTable } from '@vemedia/karibu'
import { computed } from 'vue'

interface ArticleTableCell {
    _uid?: string
    value?: string | number
}

interface ArticleTableRow {
    _uid?: string
    body?: ArticleTableCell[]
}

interface ArticleTableBlok {
    name?: string
    table?: {
        thead?: ArticleTableCell[]
        tbody?: ArticleTableRow[]
    }
}

const props = defineProps<{ blok: ArticleTableBlok }>()

const headers = computed(() => props.blok.table?.thead ?? [])
const rows = computed(() => (props.blok.table?.tbody ?? []).map(row => ({
    ...row,
    body: row.body ?? [],
})))
</script>
